export default __webpack_public_path__ + "static/media/Acudipin-Plus-ban.194bb0ff.jpg";